import type { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

import { SIMULATION_INPUT_DEFAULTS } from '../../simulation.constants'

/**
 * Lays the caller's inputs over the defaults we fill in for them. Anything with
 * no caller value and no default is left out on purpose, so a rule reading it
 * comes back as `UNRESOLVED_REFERENCE` rather than being told it's empty.
 */
export const mergeSimulationInputDefaults = ({
  triggerType,
  workflowInput
}: {
  triggerType: Dashboardv99990101Api.Automations.TriggerType | undefined
  workflowInput: Record<string, unknown>
}): Record<string, unknown> => ({
  ...(triggerType ? SIMULATION_INPUT_DEFAULTS[triggerType] : undefined),
  // A caller passing `undefined` means "I don't have this", not "use nothing
  // here", so we drop those and let the default stand.
  ...Object.fromEntries(
    Object.entries(workflowInput).filter(([, value]) => value !== undefined)
  )
})
